import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@mui/material/Button";
import jwt_decode from "jwt-decode";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import mysmartguardplus from "../../../src/assets/USA_Images/applicationLogo.svg";
import CommonUtil from "../../Util/CommonUtils";
import {
  REACT_DASHBOARD_PANEL,
  REACT_LOGIN_AUTHENTICATE,
  REACT_URL_DASHBOARD,
} from "../../actions/EndPoints";
import CustomAutocomplete from "../../components/CustomInputs/CustomAutocomplete";
import Toast from "../../components/ToastContainer/CustomToast";
import { getListSettingsById } from "../../slices/AdditionalSettings/AdditionalSettingsSlice";
import {
  getCompanies,
  webSwitchCompanyAPI,
} from "../../slices/onboard/LoginSlice";
import GlobalDataContext from "../GlobalDataContext";
import LoginLayoutV2 from "./LoginLayoutV2";
import "./custom.css";

const useStyles = makeStyles((theme) => ({
  form: {
    width: "70%",
    marginTop: theme.spacing(1),
  },
  selectcompany: {
    "& .MuiInputBase-input .MuiOutlinedInput-input .MuiInputBase-inputSizeSmall .MuiInputBase-inputAdornedEnd .MuiAutocomplete-input .MuiAutocomplete-inputFocused .css-19qh8xo-MuiInputBase-input-MuiOutlinedInput-input": {
      paddingLeft: "30px !important",
    },
  },
  submit: {
    backgroundColor: "#36c96d",
    borderRadius: "0.2rem",
    padding: "10px",
    "&:hover": {
      background: "#119743",
    },
  },
}));

function SelectCompany(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setCompany] = useState(null);
  // const [isMFAEnabled, setIsMFAEnabled] = useState(false);
  const { setCompanySettings } = useContext(GlobalDataContext);
  const [error, setError] = useState({
    companies: false,
  });

  const handleChange = (event) => {
    const name = event.target.name;
    setCompanies(event.target.value);
    setError({
      [name]: false,
    });
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  useEffect(() => {
    loadCompanies();
  }, []);

  const loadCompanies = () => {
    dispatch(getCompanies())
      .unwrap()
      .then((data) => {
        setCompanies(CommonUtil.isEmpty(data.data) ? [] : data.data.companies);
        const decoded = jwt_decode(
          localStorage.getItem(process.env.REACT_APP_TEMP_TOKEN)
            ? localStorage.getItem(process.env.REACT_APP_TEMP_TOKEN)
            : localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
        );
        var lastCompId = decoded.lastLoginCompanyId;
        if (!CommonUtil.isEmpty(data.data) && data.data.companies.length > 1) {
          const lastCompanyObj = data.data.companies.find((comp) => {
            if (comp.id === lastCompId) {
              return comp;
            }
          });
          setCompany(lastCompanyObj);
        } else {
          setCompany(data.data.companies[0]);
        }
      })
      .catch((er) => {});
  };

  // const checkLoginAuthentication = (decoded) => {
  //   var cookies = document.cookie.split(";");
  //   let secretKey = "";
  //   cookies.forEach((cookie) => {
  //     if (cookie.split("=")[0].trim() === "loginSecurityKey") {
  //       secretKey = cookie.split("=")[1];
  //     }
  //   });
  //   const payload = {
  //     email: decoded.user_name,
  //     loginSecurityKey: secretKey,
  //   };
  //   return dispatch(getLoginAuthenticationDetails(payload))
  //     .unwrap()
  //     .then((data) => {
  //       if (data.code === "MSGE4081") {
  //         const authenticationDTO = {
  //           email: decoded.user_name,
  //           userId: decoded.userId,
  //           rememberMe: false,
  //           companyId: decoded.companyId,
  //         };
  //         dispatch(generateAuthenticationCode(authenticationDTO)).unwrap();
  //         history.push({
  //           pathname: REACT_LOGIN_AUTHENTICATE,
  //           state: { data: authenticationDTO },
  //         });
  //       } else {
  //         decoded.companyType !== "NONE"
  //           ? decoded.companyType === "PARTNER"
  //             ? history.push(REACT_DASHBOARD_PANEL)
  //             : history.push(REACT_URL_DASHBOARD)
  //           : history.push(REACT_DASHBOARD_PANEL);
  //       }
  //     })
  //     .catch((er) => {});
  // };

  // const checkUserSettings = (decoded) => {
  //   let data = {
  //     userId: decoded.userId,
  //     companyId: decoded.companyId,
  //   };

  //   return dispatch(getUserSettings(data))
  //     .unwrap()
  //     .then((res) => {
  //       if (res.code === "MSGS4071" && res.data) {
  //         setIsMFAEnabled(res.data.mfaenabled);
  //         return res.data.mfaenabled;
  //       }
  //       return false;
  //     })
  //     .catch((err) => {
  //       console.error("Error fetching user settings:", err);
  //       return false;
  //     });
  // };

  const loadSetting = (companyId) => {
    dispatch(getListSettingsById(companyId))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          setCompanySettings(data.data);
          localStorage.setItem("companySettings", JSON.stringify(data.data));
        }
      });
  };

  const VerifyCompany = () => {
    if (CommonUtil.isEmptyString(selectedCompany.code)) {
      toast.error(t("VERIFYCOMP0001"));
      return;
    }

    var cookies = document.cookie.split(";");
    let secretKey = "";
    cookies.forEach((cookie) => {
      if (cookie.split("=")[0].trim() === "loginSecurityKey") {
        secretKey = cookie.split("=")[1];
      }
    });

    const payload = {
      companyId: selectedCompany.id,
      type: "",
      fcmToken: "",
      loginSecurityKey: secretKey,
    };

    dispatch(webSwitchCompanyAPI(payload))
      .unwrap()
      .then(async (data) => {
        if (data.code === "UASI0011") {
          localStorage.removeItem(process.env.REACT_APP_TEMP_TOKEN);
          localStorage.setItem(
            process.env.REACT_APP_ACCESS_TOKEN,
            "Bearer " + data.data.access_token,
          );
          localStorage.setItem(
            process.env.REACT_APP_REFRESH_TOKEN,
            data.data.refresh_token,
          );
          const decoded = jwt_decode(data.data.access_token);
          localStorage.setItem("companyId", decoded.companyId);
          localStorage.setItem("companyName", decoded.companyName);
          localStorage.setItem("companyType", decoded.companyType);
          localStorage.setItem("companyCode", decoded.companyCode);
          loadSetting(decoded.companyId);
          decoded.companyType !== "NONE"
            ? decoded.companyType === "PARTNER"
              ? history.push(REACT_DASHBOARD_PANEL)
              : history.push(REACT_URL_DASHBOARD)
            : history.push(REACT_DASHBOARD_PANEL);
        } else if (data.code === "MSGS4044") {
          const responseData = data.data;
          let mfaEnable = responseData.twoFactorAuthentication;
          if (mfaEnable) {
            const authenticationDTO = {
              email: responseData.user_name,
              userId: responseData.user_id,
              companyId: selectedCompany.id,
              rememberMe: false,
            };
            history.push({
              pathname: REACT_LOGIN_AUTHENTICATE,
              state: { data: authenticationDTO },
            });
          }
        } else {
          Toast(data.message, "error");
        }
      })
      .catch((er) => {});
  };

  function onhandleBckButton(e) {
    e.preventDefault();
    history.push("/vis/login");
  }

  return (
    <>
      {" "}
      <LoginLayoutV2 lang={true} handleClick={onhandleBckButton}>
        <Box
          style={{
            width: "55%",
            backgroundColor: "rgb(15 90 156 / 17%)",
            backdropFilter: "blur(5px)",
            padding: "40px ",
            paddingBottom: "10px",
            borderRadius: "8px",
            overflowY: "auto",
          }}
        >
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <img
                src={mysmartguardplus}
                alt="logo"
                style={{
                  opacity: 1,
                  height: "57px",
                  width: "261px",
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="h2"
                align="left"
                style={{ color: "#fff", fontWeight: "500", opacity: "1" }}
              >
                {t("VISUPDATE0006")}
              </Typography>
              <Typography
                variant="subtitle2"
                align="left"
                style={{
                  color: "rgba(255, 255, 255, 0.8)",
                  // marginBottom: "20px",
                  marginTop: "6px",
                  fontSize: "12px",
                }}
              >
                {t("VISUPDATE0009")}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <CustomAutocomplete
                className={classes.selectcompany}
                label={t("VERIFYCOMP0007")}
                onChange={(event, newValue) => {
                  if (!CommonUtil.isEmpty(newValue)) {
                    setCompany(newValue);
                  }
                }}
                value={selectedCompany}
                options={CommonUtil.isEmptyArray(companies) ? [] : companies}
                getOptionLabel={(option) => (option.name ? option.name : "")}
                required={true}
                error={error.companies}
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                paddingBottom: "16px",
              }}
            >
              <Button
                onClick={() => {
                  VerifyCompany();
                }}
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  backgroundColor: "#F2824C",
                  borderRadius: "40px !important",
                }}
              >
                {t("VERIFYCOMP0003")}
              </Button>
            </Grid>
          </Grid>
          <Box>
            <Typography
              variant="body2"
              align="center"
              style={{
                fontSize: "12px",

                color: "#fff",
              }}
            >
              {t("BACK_TO")}{" "}
              <Link href="/vis/login" className="link_green">
                {" "}
                {t("LOGINFORM0002")}
              </Link>
            </Typography>
          </Box>
        </Box>
      </LoginLayoutV2>
    </>
  );
}
export default withRouter(SelectCompany);
